import React from 'react';
import { humanCalculators } from './ConstantsHumanCalculator';
import SharedHelmet from '.././Helmet';
const TITLE = 'حواسب الزمن والتاريخ - حواسب مجانية لحساب العمر وفروق التواريخ';
const DESCRIPTION = 'استكشف مجموعة حواسب الزمن والتاريخ المجانية، بما في ذلك حواسب العمر بالتقاويم الميلادي والهجري وحواسب فروق التواريخ.';
const KEYWORDS = 'حواسب الزمن والتاريخ، حواسب مجانية، حاسبة العمر، فروق التواريخ، حاسبة التقاويم';
const OG_URL = 'https://do-calculate.com/ar/date-time-calculators';
function CalculatorsList() {
    return (
        <div className="container rtl-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-secondary" role="alert">
                    <p>{DESCRIPTION} </p>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr >
                        <th >الحاسبة</th>
                        <th >الوصف</th>
                    </tr>
                </thead>
                <tbody>
                    {humanCalculators.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;
